module.exports = __webpack_public_path__ + "media/images/story/top/bird-f2813ad4f3ef072d692feb198055ed88.png";